<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :validations="validations.tempo_atualizacao_cadastro"
                        label="Tempo de atualização do cadastro"
                        show-default-option
                        v-model="model.tempo_atualizacao_cadastro"
                    >
                        <rkm-form-select-option :value="6">6 meses</rkm-form-select-option>
                        <rkm-form-select-option :value="12">1 ano</rkm-form-select-option>
                        <rkm-form-select-option :value="18">1 ano e 6 meses</rkm-form-select-option>
                        <rkm-form-select-option :value="24">2 anos</rkm-form-select-option>
                        <rkm-form-select-option :value="30">2 anos 6 meses</rkm-form-select-option>
                        <rkm-form-select-option :value="36">3 anos</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>

                <!--<rkm-col cols="6">
                    <rkm-form-radio-group
                        :validations="validations.permite_alteracao_endereco"
                        label="Permite alteração de endereço"
                        v-model="model.permite_alteracao_endereco"
                    >
                        <rkm-form-radio :value="true">Sim</rkm-form-radio>
                        <rkm-form-radio :value="false">Não</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>-->
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('administracao-configuracao-sistema-form')
        },
        validations() {
            return {
                tempo_atualizacao_cadastro: {required: true},
                permite_alteracao_endereco: {required: true},
            }
        },
    },
    data: () => ({
        model: {
            tempo_atualizacao_cadastro: null,
            permite_alteracao_endereco: true,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading('administracao-configuracao-sistema-form')

            this.repositories.administracao.configuracaoSistema.edit()
                .then(({ data }) => {
                    this.model = Object.assign(data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading('administracao-configuracao-sistema-form'))
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated === true) {
                        this.setLoading('administracao-configuracao-sistema-form')

                        this.repositories.administracao.configuracaoSistema.update(this.model)
                            .then(({ data }) => this.$emit('save', data))
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('administracao-configuracao-sistema-form'))
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
}
</script>